import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const usageRightDefinition: ResourceDefinition = {
  title: 'Usage Rights',
  nameSingular: 'Usage rights',
  namePlural: 'Usage rights',
  className: 'UsageRight',
  mainIdentifier: 'name',
  slug: 'taxonomies/usage-rights',
  path: 'usage-rights',
  icon: 'icon-grid',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editTaxonomies',
      action: (usageRight) => ({
        type: ActionType.Link,
        link: {
          path: `${usageRightDefinition.path}/${usageRight.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deleteTaxonomies',
      action: (usageRight) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: usageRight,
          definition: usageRightDefinition
        }
      })
    }
  ]
}
